import React from "react";
import { motion } from "framer-motion";
import "./Card.css";

const Card = ({emoji, heading, detail, index = 0}) => {
  return (
    <motion.article
      className="card"
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.35 }}
      transition={{ duration: 0.45, delay: index * 0.08 }}
    >
      <img src={emoji} alt="" />
      <h3>{heading}</h3>
      <p>{detail}</p>
    </motion.article>
  );
};

export default Card;
